import React from "react";
import { useLang } from "@/contexts/LangContext";
import { cn } from "@/lib/utils";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, langs, setLang } = useLang();
  return (
    <div
      className={cn("flex items-center gap-1", className)}
      role="group"
      aria-label="Language"
      data-testid="language-selector"
    >
      {langs.map((l, i) => (
        <React.Fragment key={l.code}>
          {i > 0 && <span className="text-foreground/30 text-[10px] select-none">|</span>}
          <button
            type="button"
            data-testid={`lang-switch-${l.code}`}
            onClick={() => setLang(l.code)}
            className={cn(
              "px-1.5 py-1 text-[11px] tracking-[0.22em] uppercase transition-colors",
              lang === l.code
                ? "text-foreground"
                : "text-foreground/45 hover:text-foreground"
            )}
            aria-current={lang === l.code ? "true" : undefined}
          >
            {l.short}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
